import { FaCcAmex } from 'react-icons/fa';

const AmexCard = ({ size = 48, color = "#0077cc" }) => {
    return <FaCcAmex size={size} color={color} />
}

export default AmexCard